import { hotSearchWords } from '@/mocks/homeData';

export default function HotSearchPanel() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-search-eye-line text-accent-600"></i>
          正在被搜的词
        </h2>
        <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
          <span className="h-1.5 w-1.5 animate-live-dot rounded-full bg-accent-500"></span>
          实时
        </span>
      </div>

      <ol className="mt-4 grid grid-cols-1 gap-x-4 gap-y-2.5 sm:grid-cols-2 lg:grid-cols-1">
        {hotSearchWords.map((word, index) => (
          <li key={word}>
            <a
              href="#latest-feed"
              className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-accent-50 cursor-pointer"
            >
              <span
                className={`w-4 shrink-0 font-heading text-sm font-black ${
                  index < 3 ? 'text-accent-500' : 'text-background-400'
                }`}
              >
                {index + 1}
              </span>
              <span className="flex-1 truncate font-label text-sm text-foreground-800 group-hover:text-accent-700">
                {word}
              </span>
              <i className="ri-arrow-right-up-line text-sm text-foreground-400 group-hover:text-accent-500"></i>
            </a>
          </li>
        ))}
      </ol>
    </section>
  );
}